module.exports = __webpack_public_path__ + "static/media/unico-ferragens.f32874fc.png";